import React, {Component} from "react";
import {
  Panel,
  Modal,
  OverlayTrigger,
  Tooltip,
  Button
}                         from "react-bootstrap";
import moment             from "moment";
import axios              from "axios";
import {
  ToastContainer,
  toast
}                         from "react-toastify";
import isEqual            from "lodash.isequal";

import {
  IS_VALID,
  IS_UNDEFINED,
  IS_LENGTH_ZERO
}                         from "utils";

import saveTrail          from "utils/saveTrail";

import CrudComponent      from "../zynappse-crud";
import
PendingNotificationSchema from "./PendingNotificationSchema";
import FormContainer      from "./FormContainer";

const WEB_PATH = window.__APP_CONFIG__.webPath || 'http://localhost:3000';

class PendingNotification extends Component {
  constructor (props) {
    super(props);

    this.refreshTableReference;

    this.refreshTable = this.refreshTable.bind(this);
    this.saveNotification = this.saveNotification.bind(this);
    this.sendNotification = this.sendNotification.bind(this);
    this.uploadUserCSVFile = this.uploadUserCSVFile.bind(this);
    this.deleteData = this.deleteData.bind(this);
    this.renderModalButton = this.renderModalButton.bind(this);
    this.accessible = this.accessible.bind(this);
  }

  refreshTable () {
    if (IS_VALID(this.refreshTableReference) && typeof this.refreshTableReference === 'function') {
      this.refreshTableReference();
    }
  }

  saveNotification () {
    let {
      PendingNotification,
      actions
    } = this.props;

    let {
      selectedData,
      formType,
      formId,

      sendMode,
      userType,
      cardType,
      device,
      screen,
      browser,

      specificUser,
      blacklistedUser,

      subject,
      url,
      message,
      isSendNow,
      scheduleDateTimeNotif
    } = PendingNotification;

    if (!IS_VALID(sendMode)) {
      toast.error("Send Mode is required.");
    } else if (!IS_VALID(userType)) {
      toast.error("User Type is required.");
    }  else if (!IS_VALID(device)) {
      toast.error("Device Type is required.");
    } else if (!IS_VALID(subject) || !IS_VALID(subject.trim())) {
      toast.error("Subject is required.");
    } else if (
      IS_VALID(browser) &&
      (!IS_VALID(url) || !IS_VALID(url.trim()))
    ) {
      toast.error("Url Link is required.");
    } else if (!IS_VALID(message) || !IS_VALID(message.trim())) {
      toast.error("Message is required.");
    } else if (
      !isSendNow &&
      !moment(scheduleDateTimeNotif, "MMM DD, YYYY hh:mm A", true).isValid()
    ) {
      toast.error("Please select a valid date and time.");
    } else if (
      !isSendNow &&
      moment(scheduleDateTimeNotif).isBefore(moment())
    ) {
      toast.error("Schedule should be greater than the date and time today.");
    } else {

      const getValue = (obj) => IS_VALID(obj) && IS_VALID(obj.value) ? obj.value : '';

      let data = {
        sendMode: getValue(sendMode),
        userType: getValue(userType),
        device: getValue(device),
        sendType: isSendNow ? "IMMEDIATE" : "SCHEDULED",
        type: "REGULAR",

        subject: subject.trim(),
        message: message.trim()
      };

      if (!isSendNow) {
        data.pushDateTime = moment(scheduleDateTimeNotif).toDate();
      } else if (IS_VALID(selectedData.get("pushDateTime"))) {
        selectedData.unset("pushDateTime");
      }

      if (IS_VALID(screen) && IS_VALID(screen.label)) {
        data.screen = screen.label;
      } else if (IS_VALID(selectedData.get("screen"))) {
        selectedData.unset("screen");
      }

      if (
        IS_VALID(cardType) &&
        Array.isArray(cardType) &&
        !IS_LENGTH_ZERO(cardType)
      ) {
        data.cardTypes = cardType.map(({ label }) => label);
      } else if (IS_VALID(selectedData.get("cardTypes"))) {
        selectedData.unset("cardTypes");
      }

      if (IS_VALID(browser)) {
        data.browser = getValue(browser);
      } else if (IS_VALID(selectedData.get("browser"))) {
        selectedData.unset("browser");
      }

      if (IS_VALID(url) && IS_VALID(url.trim())) {
        data.url = url.trim();
      } else if (IS_VALID(selectedData.get("url"))) {
        selectedData.unset("url");
      }

      if (
        IS_VALID(specificUser) &&
        Array.isArray(specificUser) &&
        !IS_LENGTH_ZERO(specificUser)
      ) {
        data.specificUsers = specificUser.map((item) => item.value);
      } else if (IS_VALID(selectedData.get("specificUsers"))) {
        selectedData.unset("specificUsers");
      }

      if (
        IS_VALID(blacklistedUser) &&
        Array.isArray(blacklistedUser) &&
        !IS_LENGTH_ZERO(blacklistedUser)
      ) {
        data.blacklistedUsers = blacklistedUser.map((item) => item.value);
      } else if (IS_VALID(selectedData.get("blacklistedUsers"))) {
        selectedData.unset("blacklistedUsers");
      }

      for (let key in data) {
        if (
          key === "specificUsers" ||
          key === "blacklistedUsers" ||
          key === "cardTypes"
        ) {
          if (!IS_VALID(selectedData.get(key)) || !isEqual(selectedData.get(key), data[key])) {
            selectedData.set(key, data[key]);
          }
        } else if (
          key === "pushDateTime"
        ) {
          if (!IS_VALID(selectedData.get(key)) || !moment(data[key]).isSame(moment(selectedData.get(key)))) {
            selectedData.set(key, data[key]);
          }
        } else {
          if (
            !IS_VALID(selectedData.get(key)) ||
            selectedData.get(key) !== data[key]
          ) {
            selectedData.set(key, data[key]);
          }
        }
      }

      let dirtyKeys = selectedData.dirtyKeys();

      let changesObject = {
        objectId: selectedData.id
      };

      for (let key of dirtyKeys) {
        if (
          key === "specificUsers" ||
          key === "blacklistedUsers" ||
          key === "cardTypes"
        ) {
          changesObject[key] = IS_VALID(selectedData.get(key)) ? selectedData.get(key).join(", ") : "unset";
        } else if (
          key === "pushDateTime"
        ) {
          changesObject[key] = IS_VALID(selectedData.get(key)) ? moment(selectedData.get(key)).format("MMM DD, YYYY hh:mm A") : "unset";
        } else {
          changesObject[key] = IS_VALID(selectedData.get(key)) ? selectedData.get(key) : "unset";
        }
      }

      actions.setValue({ isLoadingAction: true });

      selectedData.save(null, { useMasterKey: false })
      .then((selectedData) => {
        actions.setValue({
          isLoadingAction: false,
          showModal: false
        });

        this.refreshTable();

        saveTrail(
          formType,
          changesObject
        );
      })
      .catch((err) => {
        console.log("saveNotification error: ", err);

        actions.setValue({
          isLoadingAction: false,
          showModal: false
        });

        this.refreshTable();
      });
    }
  }

  sendNotification (callback) {
    let {
      PendingNotification,
      actions
    } = this.props;

    let {
      selectedData
    } = PendingNotification;

    let dateApproved = moment().toDate();

    let currentUser = Parse.User.current();

    selectedData.set("Sender", currentUser);
    selectedData.set("status", "APPROVED");
    selectedData.set("dateApproved", dateApproved);

    let data = {
      Sender: currentUser,
      dateApproved: dateApproved,
      status: "ACTIVE"
    };

    let keys = [
      "type",
      "sendMode",
      "userType",
      "cardTypes",
      "device",
      "screen",
      "browser",

      "subject",
      "url",
      "message",

      "sendType",
      "pushDateTime",

      "specificUsers",
      "blacklistedUsers",
      "User"
    ];

    for (let key of keys) {
      if (IS_VALID(selectedData.get(key))) {
        if (key === "pushDateTime") {
          data[key] = moment(selectedData.get(key)).toDate();
        } else {
          data[key] = selectedData.get(key);
        }
      }
    }

    let notifications = new Parse.Object("Notifications");

    let acl = new Parse.ACL();

    acl.setPublicReadAccess(true);
    acl.setPublicWriteAccess(false);

    notifications.setACL(acl);

    notifications.set(data);

    actions.setValue({ isLoadingAction: true });

    let dirtyKeys = notifications.dirtyKeys();

    let changesObject = {
      PendingNotificationId: selectedData.id,
      status: selectedData.get("status")
    };

    for (let key of dirtyKeys) {
      if (key === "User" || key === "Sender") {
        changesObject[key] = IS_VALID(notifications.get(key)) && (notifications.get(key).get("name")) ? notifications.get(key).get("name") : notifications.get(key).get("username");
      } else if (key === "specificUsers" || key === "blacklistedUsers") {
        changesObject[key] = IS_VALID(notifications.get(key)) ? notifications.get(key).join(", ") : "";
      } else if (key === "pushDateTime" || key === "dateApproved") {
        changesObject[key] = IS_VALID(notifications.get(key)) ? moment(notifications.get(key)).format() : "";
      } else if (key !== "ACL") {
        changesObject[key] = IS_VALID(notifications.get(key)) ? notifications.get(key) : "";
      }
    }

    Promise.all([
      selectedData.save(null, { useMasterKey: false }),
      notifications.save()
    ])
    .then((data) => {
      actions.setValue(
        {
          isLoadingAction: false,
          showModal: false
        }
      );

      callback();

      this.refreshTable();

      saveTrail(
        "SEND NOTIFICATION",
        changesObject
      );
    })
    .catch((err) => {
      console.log("sendNotification error: ", err);

      selectedData.revert();

      actions.setValue(
        {
          isLoadingAction: false
        }
      );

      callback();
    });
  }

  uploadUserCSVFile (csvFile, stateName) {
    let {
      PendingNotification,
      actions
    } = this.props;

    let usersState = PendingNotification[stateName];

    actions.setValue({ isUploadingCSVFile: true });

    let fd = new FormData();

    fd.append("csvFile", csvFile);

    axios.post(
      WEB_PATH + "/MemberDetail/upload",
			fd
    )
    .then((res) => {
      let {
				data
			} = res;

      let updatedUsersState = [...usersState];

      for (let item of data) {
        if (updatedUsersState.map((item) => item.value).indexOf(item.value) === -1) {
          updatedUsersState.push({
            label: `${IS_VALID(item.memberId) ? item.memberId : ""} ${IS_VALID(item.name) ? item.name : ""}`,
            value: item.memberId
          });
        }
      }

      actions.setValue(
        {
          isUploadingCSVFile: false,
          [stateName]: updatedUsersState
        }
      );
    })
    .catch((err) => {
      console.log("uploadUserCSVFile error: ", err);

      actions.setValue({ isUploadingCSVFile: false });
    });
  }

  deleteData () {
    let {
      PendingNotification,
      actions
    } = this.props;

    let {
      selectedData
    } = PendingNotification;

    let objData = selectedData.attributes;

    let saveTrailData = {};

    for (let key in objData) {
      if (
        key !== "ACL" &&
        key !== "createdAt" &&
        key !== "updatedAt"
      ) {
        if (
          key === "User" &&
          IS_VALID(objData[key].get("name"))
        ) {
          saveTrailData[key] = objData[key].get("name");
        } else if (
          key === "blacklistedUsers" ||
          key === "cardTypes" ||
          key === "specificUsers"
        ) {
          saveTrailData[key] = JSON.stringify(objData[key]);
        } else if (
          key === "pushDateTime"
        ) {
          saveTrailData[key] = moment(objData[key]).format();
        } else {
          saveTrailData[key] = objData[key];
        }
      }
    }

    actions.setValue({ isLoadingAction: true });

    selectedData.set("isDeleted", true);

    selectedData.save(null, { useMasterKey: false })
    .then((data) => {
      actions.setValue({
        isLoadingAction: false,
        showModal: false
      });

      this.refreshTable();

      saveTrail("DELETE", saveTrailData);
    })
    .catch((err) => {
      console.log("deleteData error: ", err);

      actions.setValue({
        isLoadingAction: false,
        showModal: false
      });

      this.refreshTable();
    });
  }

  loadOptions (input, cb, className, columnName, reduxCol) {
    let query = new Parse.Query(className);

    if (typeof columnName === "string") {
      query.matches(columnName, ".*" + input + ".*", "i");
    } else {
      let queryArray = [];
      for (let column of columnName) {
        let query2 = new Parse.Query(className);
        query2.matches(column, ".*" + input + ".*", "i");
        queryArray.push(query2);
      }
      query = Parse.Query.or(...queryArray);
    }

    switch (className) {
      case "CardType":
        query.ascending("name");
        break;
      case "Screen":
        query.ascending("pageName");
        break;
    }

    query.limit(20);

    query.find()
    .then((data) => {
      const label = obj => {
        if (typeof columnName === "string") {
          return !IS_UNDEFINED(obj.get(columnName)) ? obj.get(columnName) : "";
        } else {
          return columnName
            .map(column =>
              !IS_UNDEFINED(obj.get(column)) ? obj.get(column) : ""
            )
            .join(" ");
        }
      };

      cb(
        null,
        {
          options: data.map((item) => ({
            label: label(item),
            value: className === "MemberDetail" ? item.get("memberId") : item.id
          }))
        }
      );
    })
    .catch((err) => {
      console.log("loadOptions error: ", err);
      cb(null, { options: [] });
    })
  }

  renderModalButton () {
    let {
      PendingNotification,
      actions
    } = this.props;

    let {
      isLoadingAction,
      formType
    } = PendingNotification;

    let buttons = [],
        buttonClose = (
          <Button
            disabled={isLoadingAction}
            onClick={() => {
              if (!isLoadingAction) {
                actions.setValue({ showModal: false });
              }
            }}
            >
            CLOSE
          </Button>
        ),
        button = (title = "UPDATE", action = this.saveNotification) => (
          <Button
            bsStyle="primary"
            disabled={isLoadingAction}
            onClick={() => action()}
            >
            {title}
          </Button>
        );

    switch (formType.toUpperCase()) {
      case "UPDATE":
        buttons.push(button());
        buttons.push(buttonClose);
        break;
      case "DELETE":
        buttons.push(button("DELETE", this.deleteData));
        buttons.push(buttonClose);
        break;
      default:
        buttons.push(buttonClose);
    }

    return buttons;
  }

  accessible (actionType) {
		let {
			access
		} = this.props.accessjson;

		if (access.length !== 0) {
			var currentPath = window.location.pathname,
					index = access.map((module) => module.route.toUpperCase()).indexOf(currentPath.toUpperCase()),
					actions = [];

			if (access[index]) {
				actions = access[index].actions
			}

			if (actions.length != 0) {
				if (actions.indexOf(actionType.toUpperCase()) === -1) {
					return 'none';
				} else {
					return '';
				}
			} else {
	      return 'none';
	    }
		} else {
			return 'none';
		}
	}

  render () {
    let {
      PendingNotification,
      accessjson,
      actions
    } = this.props;

    let {
      showModal,
      isLoadingAction,
      formType,
      formTitle
    } = PendingNotification;

    let viewFunction = (obj) => {
      actions.setValue(
        {
          showModal: true,
          formType: "VIEW",
          formTitle: "VIEW PENDING NOTIFICATION",
          formId: obj.id,
          selectedData: obj
        }
      );
    };

    let crudProps = {
      schema: PendingNotificationSchema,
      useMasterKey: false,
      refreshTable: (refreshTable) => { this.refreshTableReference = refreshTable; },
      moduleQuery: [
        { method: "notEqualTo", column: "isDeleted", value: true },
        { method: "ascending", column: "createdAt" },
        { method: "doesNotExist", column: "status" }
      ],
      access: accessjson.access,
      customView: viewFunction,
      customUpdate: (obj) => {
        let stateToUpdate = {
          showModal: true,
          formType: "UPDATE",
          formTitle: "UPDATE PENDING NOTIFICATION",
          formId: obj.id,
          selectedData: obj
        };

        if (IS_VALID(obj.get("sendMode"))) {
          stateToUpdate.sendMode = {
            value: obj.get("sendMode"),
            label: obj.get("sendMode")
          };
        }

        if (IS_VALID(obj.get("userType"))) {
          stateToUpdate.userType = {
            value: obj.get("userType"),
            label: obj.get("userType")
          };
        }

        if (IS_VALID(obj.get("cardTypes"))) {
          stateToUpdate.cardType = obj.get("cardTypes").map((cardType) => ({
            value: cardType,
            label: cardType
          }));
        }

        if (IS_VALID(obj.get("device"))) {
          stateToUpdate.device = {
            value: obj.get("device"),
            label: obj.get("device")
          };
        }

        if (IS_VALID(obj.get("screen"))) {
          stateToUpdate.screen = {
            value: obj.get("screen"),
            label: obj.get("screen")
          };
        }

        if (IS_VALID(obj.get("browser"))) {
          stateToUpdate.browser = {
            value: obj.get("browser"),
            label: obj.get("browser")
          };
        }

        if (IS_VALID(obj.get("subject"))) {
          stateToUpdate.subject = obj.get("subject");
        }

        if (IS_VALID(obj.get("url"))) {
          stateToUpdate.url = obj.get("url");
        }

        if (IS_VALID(obj.get("message"))) {
          stateToUpdate.message = obj.get("message");
        }

        if (IS_VALID(obj.get("sendType"))) {
          if (obj.get("sendType") === "IMMEDIATE") {
            stateToUpdate.isSendNow = true;
          } else {
            stateToUpdate.isSendNow = false;
          }
        }

        if (IS_VALID(obj.get("pushDateTime"))) {
          stateToUpdate.scheduleDateTimeNotif = moment(obj.get("pushDateTime"));
        }

        actions.setValue(stateToUpdate);
      },
      customDelete: (obj) => {
        actions.setValue({
          showModal: true,
          formType: "DELETE",
          formTitle: "DELETE PENDING NOTIFICATION",
          formId: obj.id,
          selectedData: obj
        });
      },
      customAction: ({ object, buttonView, buttonUpdate, buttonDelete }) => {
        let isApproved = IS_VALID(object.get("status")) && object.get("status").toUpperCase === "APPROVED";

        return (
          <span>
            {buttonView}
            {!isApproved ? (
              buttonUpdate
            ) : (
              ""
            )}
            {!isApproved ? (
              this.accessible("SEND NOTIFICATION") === "" ? (
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip>Send Notification</Tooltip>}
                  >
                  <a
                    style={{ color: "green" }}
                    className="fa fa-chevron-circle-right fa-lg"
                    href="javascript:void(0)"
                    onClick={() => viewFunction(object)}
                    />
                </OverlayTrigger>
              ) : (
                ""
              )
            ) : (
              ""
            )}
            {buttonDelete}
          </span>
        );
      },
      customItems: [
        {
          columnName: "subject",
          render: ({ value }) => {
            let renderValue = "";

            if (IS_VALID(value)) {
              renderValue = value.substr(0, 100).trim() + (value.length <= 100 ? "" : "...");
            }

            return renderValue;
          }
        },
        {
          columnName: "status",
          render: ({ value }) => {
            let renderValue = "";

            if (IS_VALID(value) && value.toUpperCase() === "APPROVED") {
              renderValue = <span style={{ color: "green" }}>APPROVED</span>;

            } else {
              renderValue = <span style={{ color: "gray" }}>PENDING</span>;
            }

            return renderValue;
          }
        }
      ]
    };

    let formContainerProps = {
      ...this.props,
      sendNotification: this.sendNotification,
      uploadUserCSVFile: this.uploadUserCSVFile,
      loadOptions: this.loadOptions,
      accessible: this.accessible
    };

    return (
      <div>
        <Panel>
          <Panel.Heading
            style={{
              backgroundColor: '#D1282F',
              color: 'white'
            }}
            >
            <h4>PENDING NOTIFICATION</h4>
          </Panel.Heading>
          <Panel.Body>
            <CrudComponent {...crudProps}/>
          </Panel.Body>
        </Panel>
        <Modal
          bsSize={formType.toUpperCase() === "UPDATE" ? "large" : null}
          backdrop="static"
          show={showModal}
          onHide={() => {
            if (!isLoadingAction) {
              actions.setValue(
                {
                  showModal: false
                }
              );
            }
          }}
          >
          <Modal.Header closeButton>
            <Modal.Title>{(IS_VALID(formTitle) ? formTitle : formType).toUpperCase()}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <FormContainer {...formContainerProps}/>
          </Modal.Body>
          <Modal.Footer>
            {this.renderModalButton()}
          </Modal.Footer>
        </Modal>
        <ToastContainer/>
      </div>
    );
  }
}

import {connect}            from 'react-redux';
import {bindActionCreators} from 'redux';
import {generics}           from 'actions';
import {
  PENDING_NOTIFICATION
}                           from "actions/const";

function mapStateToProps(state) {
  let {
    PendingNotification,
    accessjson
  } = state;

  return {
    PendingNotification,
    accessjson
  };
}

function mapDispatchToProps(dispatch) {
  const actions = {
    setValue: (keyValueObject, actionType = PENDING_NOTIFICATION) => generics.setValue(actionType, keyValueObject)
  };

  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PendingNotification);



// WEBPACK FOOTER //
// ./components/PendingNotification/index.js